// PTMQRVA-506: mapeo de roles del PRD (Gestión de credenciales para el portal
// de comercios — id Confluence 6969753603) a los permission strings que los
// AuthGuards del portal ya usan. Reemplaza el claim `permissions[]` del tenant
// viejo (playdigital) por el claim `https://modo-auth0/roles` que emite el
// tenant `portal-modo-develop`, sin tocar cada componente que monta un
// AuthGuard.

import { Permissions } from './constants';

const ALL_PERMS = Object.values(Permissions.PermissionsList) as string[];

export const Roles = {
  ADMIN: 'admin',
  CENTRAL: 'Central',
  TXS_VIEW: 'transactions-view',
  TXS_DOWNLOAD: 'transactions-download',
  ADMIN_COMERCIO: 'comercios-admin',
  CONSULTA_TXS: 'comercios-consulta',
  DESCARGA_TXS: 'comercios-descarga',
  PROMOCIONES: 'comercios-promociones',
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];

const ROLE_PERMISSIONS: Record<string, string[]> = {
  [Roles.ADMIN]: ALL_PERMS,
  [Roles.CENTRAL]: [Permissions.PermissionsList.ReadStatusService],
  [Roles.TXS_VIEW]: [
    Permissions.PermissionsList.ReadTransactions,
    Permissions.PermissionsList.ReadP2mInfo,
  ],
  [Roles.TXS_DOWNLOAD]: [
    Permissions.PermissionsList.ReadTransactions,
    Permissions.PermissionsList.DownloadTransactions,
    Permissions.PermissionsList.ReadP2mInfo,
  ],
  [Roles.ADMIN_COMERCIO]: ALL_PERMS,
  [Roles.CONSULTA_TXS]: [
    Permissions.PermissionsList.ReadTransactions,
    Permissions.PermissionsList.ReadP2mInfo,
  ],
  [Roles.DESCARGA_TXS]: [
    Permissions.PermissionsList.ReadTransactions,
    Permissions.PermissionsList.DownloadTransactions,
    Permissions.PermissionsList.ReadP2mInfo,
  ],
  // Los permisos de este rol se retiraron junto con las
  // secciones del portal (Calendario de promos, Gestión de promos). El rol se
  // conserva para que rolesToPermissions siga resolviendo usuarios que aún lo
  // tengan asignado en el tenant.
  [Roles.PROMOCIONES]: [],
};

export function rolesToPermissions(roles: string[] | undefined | null): string[] {
  if (!roles || roles.length === 0) return [];
  const out = new Set<string>();
  for (const role of roles) {
    const perms = ROLE_PERMISSIONS[role];
    if (!perms) continue;
    perms.forEach((p) => out.add(p));
  }
  return Array.from(out);
}
